import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-6.5 md:mt-5',
    accordion: 'border-y-0',
    accordionHeader: 'px-0 md:px-0',
    accordionHeaderIconWrapper: 'ml-2',
    accordionContentWrapper: 'px-0 md:px-0',
    header: 'heading-m-regular w-max',
    button: 'w-max px-3',
    buttonContent: 'flex items-center gap-2',
    content: 'flex w-full flex-wrap gap-4 pt-1',
    buttonIcon: 'h-6 w-10'
  }
});
